import { render, staticRenderFns } from "./KasbonExternalView.vue?vue&type=template&id=70cc5004"
import script from "./KasbonExternalView.vue?vue&type=script&lang=js"
export * from "./KasbonExternalView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports